
import request from '@/util/request';
// import qs from 'qs';

// 列表
export const getPaymentStageList = (params, options) =>
    request.get('/api/v4ward/contract/paymentstage/page', Object.assign({}, options, { params }));
// 详情
export const getContractDetail = (params, options) =>
    request.get('/api/v4ward/contract/detail', Object.assign({}, options, { params }));

// 字典数据
//  合同阶段 : contract_lifecycle
//  收付款类型 : contract_payment
//  发票类型 : invoice_type
export const getDictData = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));


// 业务字典数据
//  获取税率 : code = project_contract_invoice_tax_rate & projectId = XXX
//  合同类型 : code = project_contract_type  & projectId = XXX
export const getBisDictData = (params, options) =>
    request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

//文件上传
export const putFile = (data, options) =>
    // request.post('/api/blade-resource/oss/endpoint/put-file', data, options);
    request.post('/api/v4ward/oss/customEndpoint/put-file', data, options);
// 合同新增
export const saveContract = (data, options) =>
    request.post('/api/v4ward/contract/save', data, options);
// 合同编辑
export const editContract = (data, options) =>
    request.post('/api/v4ward/contract/update', data, options);
// 修改关联合同
export const updateLinkContract = (data, options) =>
    request.post('/api/v4ward/contract/updateLinkContract', data, options);
// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));
// 合同对象列表
export const getPartnerList = (params, options) =>
    request.get('/api/v4ward/partner/partnerlist', Object.assign({}, options, { params }));
// 责任人
// 入参:projectId
export const userList = (params, options) =>
    request.get('/api/v4ward/user/project-user-list', Object.assign({}, options, { params }));
// 关联合同列表
export const getRelativeContractList = (params, options) =>
    request.get('/api/v4ward/contract/searchlist', Object.assign({}, options, { params }));

    // 下载文件接口
export const downloadFile = (fileUrl,fileName) => {
    let url = "/api/v4ward/oss/customEndpoint/downloadFile?fileUrl="+fileUrl+"&fileName="+fileName;
    let  a = document.createElement('a');           // 创建隐藏的可下载链接
    a.download = fileName;
    a.style.display = 'none';
    a.href = url;
    document.body.appendChild(a);
    a.click();                                                       // 触发点击
    document.body.removeChild(a);                  // 然后移除
  }



